import storage from '@aws-amplify/storage'
import auth from '@aws-amplify/auth'

// This file contains custom plugins which allow access to $-prefixed properties/methods
// on the Vue instance. Once created here, they should be imported into the 'main.js' file
// where the Vue app is instanciated and added with 'Vue.use($myPlugin)'.

// Will give access to 'this.$auth' in the app for quickly using AWS cognito api
export const Auth = {
  install: function (Vue, name = '$auth') {
    Object.defineProperty(Vue.prototype, name, { value: auth })
  }
}

// Will give access to 'this.$s3' in the app for quickly using AWS storage api
export const S3 = {
  install: function (Vue, name = '$s3') {
    Object.defineProperty(Vue.prototype, name, { value: storage })
  }
}
